"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var single_1 = require("utils/selectors/single");
var TeamCreationInput_1 = __importDefault(require("./TeamCreationInput"));
var WizardParts_1 = require("./WizardParts");
var SetMyTeamBase = function (_a) {
    var stepIdx = _a.stepIdx;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var teams = (0, react_final_form_1.useField)('teams', { subscription: { value: true } }).input.value;
    var myTeam = teams.find(function (t) { return t.leaderId === profile.id; });
    return ((0, jsx_runtime_1.jsx)(WizardParts_1.StepTemplate, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ height: "100%", minHeight: 500 }, { children: [(0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 1, sx: { mt: 4 } }, { children: [stepIdx + 1, ". Create your team"] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, sx: { mt: 1 } }, { children: " A team can represent a department or function within your organisation." })), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "teams", component: TeamCreationInput_1.default, isUserLeader: true, disabled: !!myTeam })] })) }));
};
exports.default = SetMyTeamBase;
